import styled from 'styled-components';

export const Page = styled.div`
    color: #ffffff;
    font-family: 'Inter', sans-serif;
    min-height: 100vh;
    width: 100%;

    * {
        box-sizing: border-box;
    }
`;

export const GradientWrap = styled.div`
    height: 100vh;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: -500;
`;

export const HeaderWrap = styled.div`
    padding: 48px 48px 0;
    width: 100%;

    @media (max-width: 768px) {
        padding: 24px 24px 0;
    }
`;

export const Main = styled.main`
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 0 auto;
    max-width: 1280px;
    min-width: 0;
    padding: 56px 48px 64px;
    width: 100%;

    @media (max-width: 768px) {
        padding: 32px 20px 48px;
    }
`;

export const Lead = styled.p`
    color: rgba(255, 255, 255, 0.72);
    font-size: 15px;
    font-weight: 500;
    line-height: 1.5;
    margin: -8px 0 0;
    max-width: 62ch;
`;

export const TextButton = styled.button`
    background: none;
    border: 0;
    color: #ffffff;
    cursor: pointer;
    font-family: inherit;
    font-size: inherit;
    font-weight: 600;
    padding: 0;
    text-decoration: underline;
`;

export const Banner = styled.div`
    background: rgba(176, 42, 55, 0.28);
    border: 1px solid rgba(176, 42, 55, 0.7);
    border-radius: 12px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
    padding: 12px 14px;
`;

export const Empty = styled.div`
    color: rgba(255, 255, 255, 0.72);
    font-size: 15px;
    font-weight: 500;
    padding: 36px 16px;
    text-align: center;
`;
